import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import BookingCalendar from '../../components/feature/BookingCalendar';

export default function ChiSonoPage() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  const openBookingCalendar = () => {
    setIsBookingOpen(true);
  };

  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById('contatti');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <>
      <Header onContactClick={scrollToContact} />
      
      <main className="min-h-screen bg-white">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h1 className="text-5xl font-bold text-gray-900 mb-6">
                  Chi Sono
                </h1>
                <p className="text-xl text-gray-600 mb-8">
                  Arnaldo Gobbo, il tuo esperto di fiducia per contratti di locazione 
                  sicuri e conformi alla normativa vigente.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button 
                    size="lg"
                    onClick={openBookingCalendar}
                  >
                    <i className="ri-calendar-line mr-2"></i>
                    Prenota Consulenza
                  </Button>
                  <Button 
                    variant="outline" 
                    size="lg"
                    onClick={() => document.getElementById('esperienza')?.scrollIntoView({ behavior: 'smooth' })}
                  >
                    <i className="ri-arrow-down-line mr-2"></i>
                    Scopri di Più
                  </Button>
                </div>
              </div>
              <div className="relative">
                <img
                  src="/images/chi-sono-hero.png"
                  alt="Arnaldo Gobbo - Agente Immobiliare Esperto"
                  className="w-full h-auto rounded-2xl shadow-2xl object-cover object-top"
                />
                <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-6 shadow-lg">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                      <i className="ri-award-fill text-white text-xl"></i>
                    </div>
                    <div>
                      <p className="font-bold text-gray-900">20+ Anni</p>
                      <p className="text-sm text-gray-600">di Esperienza</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Esperienza Section */}
        <section id="esperienza" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                La Mia Esperienza
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Oltre vent'anni di esperienza nel settore immobiliare, 
                specializzato nelle locazioni e nella gestione contrattuale.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="space-y-8">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-user-star-fill text-blue-600 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        Arnaldo Gobbo
                      </h3>
                      <p className="text-gray-600">
                        Agente immobiliare professionale con patentino TV 2129, 
                        specializzato in contratti di locazione e gestione immobiliare.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-fill text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        20 Anni di Esperienza
                      </h3>
                      <p className="text-gray-600">
                        Due decenni di esperienza nel settore delle locazioni, 
                        con migliaia di contratti redatti e gestiti con successo.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-shield-check-fill text-purple-600 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        Patentino TV 2129
                      </h3>
                      <p className="text-gray-600">
                        Agente immobiliare abilitato e regolarmente iscritto, 
                        garanzia di professionalità e competenza nel settore.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative">
                <img
                  src="/images/office-workspace.jpg"
                  alt="Ufficio Professionale Arnaldo Gobbo"
                  className="w-full h-auto rounded-2xl shadow-lg object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Competenze Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Le Mie Competenze
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Specializzazioni e aree di expertise nel settore immobiliare
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-file-text-fill text-blue-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Contratti di Locazione
                </h3>
                <p className="text-gray-600">
                  Redazione di contratti personalizzati conformi alla normativa vigente, 
                  con particolare attenzione ai dettagli legali e fiscali.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-government-fill text-green-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Registrazione Agenzia Entrate
                </h3>
                <p className="text-gray-600">
                  Gestione completa delle pratiche di registrazione presso l'Agenzia delle Entrate, 
                  garantendo conformità fiscale e tempistiche ottimali.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-pen-nib-fill text-purple-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Firma Digitale
                </h3>
                <p className="text-gray-600">
                  Servizi di firma digitale remota per contratti, 
                  garantendo validità legale e comodità per tutte le parti.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-video-chat-fill text-orange-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Consulenza Online
                </h3>
                <p className="text-gray-600">
                  Consulenze professionali in videoconferenza per analizzare 
                  le tue esigenze e fornirti soluzioni personalizzate.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-shield-user-fill text-red-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Tutela Legale
                </h3>
                <p className="text-gray-600">
                  Protezione completa per proprietari e inquilini attraverso 
                  contratti redatti secondo le migliori pratiche legali.
                </p>
              </div>

            </div>
          </div>
        </section>

        {/* Perché Scegliermi Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Perché Scegliere Arnaldo Gobbo
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                La mia esperienza ventennale al tuo servizio per contratti di locazione sicuri e conformi
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <img
                  src="/images/professional-meeting.jpg"
                  alt="Professionalità e Fiducia"
                  className="w-full h-auto rounded-2xl shadow-lg object-cover object-top"
                />
              </div>

              <div className="space-y-8">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Esperienza Consolidata
                    </h3>
                    <p className="text-gray-600">
                      20 anni di esperienza nel settore immobiliare con focus specifico 
                      sulle locazioni e gestione contrattuale.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Abilitazione Professionale
                    </h3>
                    <p className="text-gray-600">
                      Agente immobiliare regolarmente iscritto con patentino TV 2129, 
                      garanzia di competenza e professionalità.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Servizio Personalizzato
                    </h3>
                    <p className="text-gray-600">
                      Ogni contratto è redatto su misura per le specifiche esigenze 
                      del cliente, garantendo massima tutela legale.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Tecnologia Avanzata
                    </h3>
                    <p className="text-gray-600">
                      Utilizzo di strumenti digitali moderni per consulenze online, 
                      firma digitale e gestione documentale efficiente.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-blue-600 to-indigo-700">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Pronto a Iniziare?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Prenota la tua consulenza gratuita e scopri come posso aiutarti 
              a gestire i tuoi contratti di locazione in modo sicuro e professionale.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                size="lg" 
                variant="outline"
                className="bg-white text-blue-600 border-white hover:bg-blue-50"
                onClick={openBookingCalendar}
              >
                <i className="ri-calendar-line mr-2"></i>
                Consulenza Gratuita
              </Button>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      
      <BookingCalendar 
        isOpen={isBookingOpen} 
        onClose={() => setIsBookingOpen(false)} 
      />
    </>
  );
}